/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceCategoryModel } from '../../models/service-category-model';

export interface ServiceCategoryIdGet$Params {
  id: string;
}

export function serviceCategoryIdGet(http: HttpClient, rootUrl: string, params: ServiceCategoryIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ServiceCategoryModel>> {
  const rb = new RequestBuilder(rootUrl, serviceCategoryIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<ServiceCategoryModel>;
    })
  );
}

serviceCategoryIdGet.PATH = '/ServiceCategory/{id}';
